export default "__VITE_ASSET__C9pHO6Nc__"